import React from "react";
import Spinner from "../../../common/Icons/Spinner/Spinner";
import useCheckMobileScreen from "../../../../utils/common/useCheckMobileScreen";

const TableSkeleton = () => {
  const isMobile = useCheckMobileScreen();
  return (
    <div className="relative">
      <div className="absolute h-full w-full flex justify-center items-center z-10">
        <Spinner />
      </div>
      {/* display a div 4 times */}
      {[...Array(4)].map((e, i) => (
        <div
          className="p-5 border-gray-200 border-b border-x border-dashed flex items-center space-x-5"
          // eslint-disable-next-line react/no-array-index-key
          key={i}
        >
          {!isMobile && (
            <>
              <div className="flex flex-1 items-center space-x-5 mr-10">
                <div className="h-4 w-4 bg-gray-100 rounded-sm skeleton-box" />
                <div className="flex-1 rounded bg-gray-100 h-2 skeleton-box" />
              </div>
              <div className="flex flex-1 items-center space-x-5">
                <div className="flex-1 rounded bg-gray-100 h-2 skeleton-box" />
                <div className="flex-1 rounded bg-gray-100 h-2 skeleton-box" />
              </div>
              <div className="flex flex-1 items-center space-x-5">
                <div className="flex-1 rounded bg-gray-100 h-2 skeleton-box" />
                <div className="flex-1 rounded bg-gray-100 h-2 skeleton-box" />
              </div>
            </>
          )}
          {/* display 4 divs with equal height and width */}
          {[...Array(4)].map((elt, j) => (
            <div
              className="h-2 flex-1 bg-gray-100 rounded skeleton-box"
              // eslint-disable-next-line react/no-array-index-key
              key={j}
            />
          ))}
          <div className="h-6 bg-gray-100 rounded skeleton-box flex-1 ml-10" />
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
